import { render, staticRenderFns } from "./IntegrationGamesList.vue?vue&type=template&id=5a62ede1&scoped=true&"
import script from "./IntegrationGamesList.vue?vue&type=script&lang=js&"
export * from "./IntegrationGamesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a62ede1",
  null
  
)

export default component.exports